<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex x16>
        <v-card>
          <v-card-title>
            <v-text-field v-model="search" type="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="openModalCreate()">New Group</v-btn>
          </v-card-title>
          <v-data-table
              :headers="headers"
              :items="deviceGroups"
              :items-per-page="5"
              class="elevation-5"
          >
          <template slot="headerCell" slot-scope="props">
            <span>{{ props.header.text }}</span>
          </template>
          
          <template slot="items" slot-scope="props">
            <td class="">{{ props.item.name }}</td>
            <td class="">{{ props.item.description }}</td>
            <td class="">{{ props.item.type }}</td>
            <td class="">
                <span v-for="item in props.item.managers" :key="item.id">
                    {{ item.name }} |
                </span>
            </td>
            <td class="">{{ props.item.parent_id }}</td>
            <td class="justify-center layout px-0">
                <v-btn fab flat small color="primary mr-1" @click="openModalEdit(props.item, props.index)">
                <v-icon small>edit</v-icon>
                </v-btn>
                <v-btn fab flat small color="red" @click="deleteItem(props.item, props.index)">
                <v-icon small >delete</v-icon>
                </v-btn>
            </td>
          </template>
        </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <ModalCreate v-if="showModalCreate" v-on:closeModal="closeModalCreate" v-on:addDeviceGroup="addDeviceGroupList" :itemEdit="selectItemActive" v-on:updateDeviceGroup="updateDeviceGroupList"></ModalCreate>
    <ModalDelete v-if="showModalDelete" v-on:closeModal="closeModalDelete" :itemDelete ="selectItemActive" v-on:deleteDeviceGroup="deleteDeviceGroupList"></ModalDelete>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import ModalCreate from './ModalCreate.vue';
import ModalDelete from './ModalDelete.vue';

export default {
  components: {
    ModalCreate,
    ModalDelete
  },
  data () {
    return {
      search: '',
      showModalCreate: false,
      showModalDelete: false,
      selectItemActive: null,
      pagination: {
        rowsPerPage: 25
      },
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'client',
        },
        { text: 'Description', value: 'description' },
        { text: 'Type', value: 'type' },
        { text: 'Managers', value: 'managers' },
        { text: 'Parent', value: 'parent' },
        { text: 'Actions', value: 'actiions', sortable: false }
      ],
      deviceGroups: [],
    };
  },
  computed: {
    ...mapGetters(['loading', 'clients', 'client'])
  },
  watch: {
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      this.$store.commit('setLoading', true);
      let url = '/client/devicegroups';
      window.axios.get(url).then((response) => {
        this.deviceGroups = response.data.data;
        this.$store.commit('setLoading', false);
      });
    },
    openModalCreate () {
      this.showModalCreate = true;
    },
    closeModalCreate () {
      this.showModalCreate = false;
      this.selectItemActive = null;
    },
    addDeviceGroupList (deviceGroup) {
      this.deviceGroups.unshift(deviceGroup);
    },
    deleteItem (item, index) {
      item.index = index;
      this.selectItemActive = item;
      this.showModalDelete = true;
    },
    closeModalDelete (item) {
      this.showModalDelete = false;
      this.selectItemActive = null;
    },
    deleteDeviceGroupList (deviceGroup) {
      this.deviceGroups.splice(deviceGroup, 1);
      this.showModalDelete = false;
      this.selectItemActive = null;
    },
    openModalEdit (deviceGroup, index) {
      this.showModalCreate = true;
      deviceGroup.index = index;
      this.selectItemActive = deviceGroup;
    },
    updateDeviceGroupList (item) {
      this.deviceGroups[item.index].name = item.value.name;
      this.deviceGroups[item.index].description = item.value.description;
      this.deviceGroups[item.index].managers = item.value.managers;
      this.deviceGroups[item.index].parent_id = item.value.parent_id;
    }
  }
};
</script>
<style>
  .d-flex{
    display: flex;
  }
  .text-center{
    text-align: center;
  }
  .color{
    display: block;
    width: 50px;
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/devicegroups/List.vue